import { Dialog } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { DialogEventHandler } from '@/types'
import Content from './content'
type Props = {
  visible: boolean
  closeModal: DialogEventHandler
}

const BuySyndicationCreditsModal = ({ visible, closeModal }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog
      id="BuySyndicationCreditsModal"
      title={t(
        'l.usage.dialog.buy_multi_sponsored_listings.title',
        'Buy Sponsored Listings credits'
      )}
      open={visible}
      onClose={closeModal}
    >
      <Content closeModal={closeModal} />
    </Dialog>
  )
}

export default BuySyndicationCreditsModal
